import { agent, API_MAP } from 'helpers';

class CustomerService {
  static loadCustomerByEmail(email: any) {
    return agent.get(`${API_MAP.loadCustomerByEmail}`.replace('{email}', encodeURIComponent(email)));
  }

  static loadCustomerById(id: any) {
    return agent.get(`${API_MAP.customer}`.replace('{id}', id.toString()));
  }

  static updateCustomerById(id: any, data: any) {
    return agent.put(`${API_MAP.customer}`.replace('{id}', id.toString()), data);
  }

  static sendCustomerSurvey(customerId: number, survey: any) {
    return agent.post(`${API_MAP.customerSurvey}`.replace('{id}', customerId.toString()), survey);
  }

  static markOrbitaAbandonment(customerId: number, reason: string) {
    return agent.post(`${API_MAP.markOrbitaAbandonment}`.replace('{id}', customerId.toString()), { reason });
  }

  static checkIfUserhaveCoproductionGains() {
    return agent.get(`${API_MAP.checkIfUserhaveCoproductionGains}`);
  }
}

export default CustomerService;
